import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import React, { CSSProperties } from 'react';

interface PreviewPdfProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  pdf: string;
  downloadLoadingPdf: boolean;
}

const PreviewPdf: React.FC<PreviewPdfProps> = ({
  open,
  setOpen,
  pdf,
  downloadLoadingPdf,
}) => {
  const handleClose = () => {
    setOpen(false);
  };
  const iframeStyle: CSSProperties = {
    width: '100%',
    height: 'calc(100vh - 100px)',
    overflowX: 'hidden',
    overflowY: 'auto',
  };
  return (
    <>
      <Dialog
        open={open}
        maxWidth="xl"
        onClose={handleClose}
        fullWidth
        sx={{
          '& .MuiPaper-root': {
            maxWidth: '100%',
            width: '95vw',
          },
        }}
      >
        <DialogTitle>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            <Typography variant="h6">Preview Report</Typography>

            <IconButton onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <Divider />
        <DialogContent sx={{ padding: 0, overflow: 'hidden' }}>
          {downloadLoadingPdf && pdf ? (
            <CircularProgress size={50} />
          ) : (
            <Box display="flex" alignItems="center" justifyContent="center">
              <iframe src={pdf} title="Preview Pdf" style={iframeStyle} />
            </Box>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};

export default PreviewPdf;
